import { SET_CURRENT_GROUP_ID } from 'shared/constants/actionTypes';

export const setCurrentGroupId = groupId => ({
  type: SET_CURRENT_GROUP_ID,
  payload: groupId
});
